export function isInIFrame(): boolean {
	return window.self !== window.top
}



// WEBPACK FOOTER //
// ./src/utils/WindowUtils.ts